const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
const gstRegex =
  /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/
const addressRegex = /(?=.[a-zA-Z0-9])[a-zA-Z0-9@#$%&()-+=|/:;.,<>?[\]{}\-_ ]*$/
const VALID_TLDS = [
  'com',
  'net',
  'org',
  'edu',
  'gov',
  'io',
  'co',
  'us',
  'uk',
  'info',
  'biz',
  'dev',
  'app',
  'ai',
  'me',
  'ca',
  'in',
]

const UDYAM_REGEX = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/

function isValidTLD(email) {
  const parts = email.toLowerCase().split('.')
  if (parts.length < 2) return false

  const tld = parts[parts.length - 1]
  return VALID_TLDS.includes(tld)
}

export function isEmailValid(email: string) {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
  if (emailRegex.test(email) && isValidTLD(email)) {
    return true
  }
  return false
}
export function isPanorGSTValid(panGst: string) {
  return isPanValid(panGst) || isGstValid(panGst)
}

export function isPanValid(pan: string) {
  // TODO: !! Remove this hardcoded check.
  if (pan === '27AAICA3919J1CT') {
    return true
  }
  return panRegex.test(pan)
}

export function isGstValid(gst: string) {
  // TODO: !! Remove this hardcoded check.
  if (gst === '27AAICA3919J1CT') {
    return true
  }
  return gstRegex.test(gst)
}

// TODO: Prefer `string` over `any`
export function isEmpty(value: any) {
  return value === '' || value === null || value === undefined
}

export function isValidAddressString(value: string) {
  return addressRegex.test(value?.trim())
}

export function isValidMobileNumber(number: string) {
  const mobileRegex = /^[6-9]\d{9}$/
  return mobileRegex.test(number)
}
export function isValidName(name: string) {
  const nameRegex = /^[A-Za-z\s'-]{2,50}$/
  return nameRegex.test(name)
}
export function isValidShopName(name: string) {
  const nameRegex = /^[a-zA-Z0-9&'.\-\s]{2,50}$/
  return nameRegex.test(name)
}

export function isValidUdyam(udyam: string) {
  return UDYAM_REGEX.test(udyam?.toUpperCase())
}
